import Vue from "vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import {
  email,
  numeric,
  max,
  confirmed
} from "vee-validate/dist/rules";
import {
  cmtnd,
  EMAIL_INVALID,
  minxMax,
  maxLength,
  NEW_CMTND_NUMBER,
  NUMERIC,
  OLD_CMTND_NUMBER,
  phoneNumber,
  fax,
  REQUIRED,
  REQUIRED_FIELD,
  REQUIRED_SELECT,
  TOM_TAT_THONG_BAO_MAX_LENGTH,
  CODE_VALIDATE,
  CODE_UTF
} from "@/constants/validateMessages";
import { lowerCase } from "bootstrap-vue/esm/utils/string";
import { CONFIRM_PASSWORD, passWord } from "../constants/validateMessages";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

extend("required", {
  validate(value, { input }) {
    if (["", null, undefined].indexOf(value) === -1) {
      return true;
    }
    let message = REQUIRED;
    if (input === "select") message = REQUIRED_SELECT;

    return message;
  },
  params: ["input"],
  computesRequired: true
});

extend("requiredMultiple", {
  validate(value) {
    if (["", null, undefined].indexOf(value) === -1 && value && value.length) {
      return true;
    }
    return REQUIRED_SELECT;
  },
  params: ["input"],
  computesRequired: true
});

extend("email", {
  ...email,
  message: EMAIL_INVALID
});
extend("confirmed", {
  ...confirmed,
  message: CONFIRM_PASSWORD
});
extend("numeric", {
  ...numeric,
  message: NUMERIC
});

extend("maxlength", {
  validate(value, args) {
    const length = (value || "").length;
    if (length <= args.max) {
      return true;
    }

    return maxLength(args.max);
  },
  params: ["max"]
});

extend("minmax", {
  validate(value, args) {
    const length = value.length;

    if (length >= args.min && length <= args.max) {
      return true;
    }

    return minxMax(args.min, args.max);
  },
  params: ["min", "max"]
});
extend("password", {
  validate(value) {
    const length = value;

    if (length.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{8,})$/)) {
      return true;
    }

    return passWord();
  },
  params: ["min", "max"]
});
extend("phone_number", {
  validate(value, args) {
    const length = value.length;

    if (
      length >= args.min &&
      length <= args.max &&
      !isNaN(value) &&
      !value.includes(" ")
    ) {
      return true;
    }

    return phoneNumber(args.min, args.max);
  },
  params: ["min", "max"]
});

extend("fax", {
  validate(value, args) {
    const length = value.length;

    if (
      length >= args.min &&
      length <= args.max &&
      !isNaN(value) &&
      !value.includes(" ")
    ) {
      return true;
    }

    return fax(args.min, args.max);
  },
  params: ["min", "max"]
});
extend("cmtnd", {
  validate(value) {
    const length = value.length;

    if (length === OLD_CMTND_NUMBER || length === NEW_CMTND_NUMBER) {
      return true;
    }

    return cmtnd();
  }
});
extend("required_field", {
  validate(value, args) {
    if (value !== "") {
      return true;
    }

    return args.fieldName
      ? REQUIRED_FIELD(lowerCase(args.fieldName))
      : REQUIRED;
  },
  params: ["fieldName"],
  computesRequired: true
});
extend("max", {
  ...max,
  message: TOM_TAT_THONG_BAO_MAX_LENGTH
});

extend("code", {
  validate(value) {
    if (!value) {
      return true;
    }
    if (value.indexOf(" ") === -1) {
      return true;
    }

    return CODE_VALIDATE;
  },
  params: ["input"],
  computesRequired: true
});

extend("hashcode", {
  validate(value) {
    for (var i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) > 127) return CODE_UTF;
    }

    return true;
  },
  params: ["input"],
  computesRequired: true
});
